(function () {
    'use strict';

    angular.module('pharmaPortalApp').config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('pharma-dashboard', {
            parent: 'entity',
            url: '/pharma-dashboard',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'pharmaPortalApp.pharmaDashboard.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/pharma-dashboard/pharma-dashboard.html',
                    controller: 'PharmaDashboardController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('pharmaDashboard');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
    }
})();
